import { Fragment, useEffect, useState } from "react";
import { Col, Row } from "reactstrap";
import Chart from "react-google-charts";
import CollapseableCard from "../../../CommonElements/Collapse/CollapseableCard";

const TotalStackChart = (props) => {
  const [countedData, setCountedData] = useState([
    ["Unit Kerja", "Realisasi (%)", "Sisa (%)"],
  ]);

  const { updatedanggaranbuklist } = props;

  useEffect(() => {
    if (updatedanggaranbuklist && updatedanggaranbuklist.length > 0) {
      getCountData(updatedanggaranbuklist);
    }
  }, [updatedanggaranbuklist]);

  const getCountData = (data) => {
    let filterData = data.filter(
      (item) => item.id_unit_kerja !== "Fasilkom" && item.total_anggaran !== "0"
    );

    const newCountedData = filterData.map((item) => {
      const terpakai = parseInt(item.total_terpakai);
      const total = parseInt(item.total_anggaran);
      const sisa = parseInt(item.total_sisa);
      const realisasi = ((terpakai / total) * 100).toFixed(2);
      const sisaPersen = ((sisa / total) * 100).toFixed(2);
      return [
        item.id_unit_kerja,
        parseFloat(realisasi),
        parseFloat(sisaPersen),
      ];
    });

    newCountedData.sort((a, b) => b[2] - a[2]);

    setCountedData((prevData) => [...prevData, ...newCountedData]);
  };

  const options = {
    chartArea: { width: "60%", height: "80%" },
    isStacked: true,
    hAxis: {
      title: "Unit Kerja",
      minValue: 0,
    },
    vAxis: {
      title: "Persentase",
    },
    bar: { groupWidth: "75%" },
    colors: ["#ef6057", "#5fdc73"],
  };

  return (
    <Fragment>
      <Col {...props}>
        <CollapseableCard title={"Persentase Anggaran"}>
          <Row>
            <Col>
              <div
                id="barchart"
                className="d-flex justify-content-center overflow-auto"
              >
                <Chart
                  chartType="ColumnChart"
                  width="100%"
                  height="400px"
                  data={countedData}
                  options={options}
                  style={{ overflow: "hidden" }}
                />
              </div>
            </Col>
          </Row>
        </CollapseableCard>
      </Col>
    </Fragment>
  );
};

export default TotalStackChart;
